import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../store/store';

interface ParticipantState {
  tenantId: string | null;
  participantId: string | null;
  esppParticipantId: string | null;
}

const sliceState: ParticipantState = {
  tenantId: null,
  participantId: null,
  esppParticipantId: null,
};

const participantSlice = createSlice({
  name: 'participant',
  initialState: sliceState,
  reducers: {
    setParticipantCredentials: (
      state,
      {
        payload: { tenantId, participantId, esppParticipantId },
      }: PayloadAction<{ tenantId: string; participantId: string; esppParticipantId: string }>
    ) => {
      state.tenantId = tenantId;
      state.participantId = participantId;
      state.esppParticipantId = esppParticipantId;
    },
  },
});

export const { setParticipantCredentials } = participantSlice.actions;

export default participantSlice.reducer;

export const selectTenantId = (state: RootState): string | null => state?.participant?.tenantId;

export const selectParticipantId = (state: RootState): string | null =>
  state?.participant?.participantId;

export const selectEsppParticipantId = (state: RootState): string | null =>
  state?.participant?.esppParticipantId;
